import { IconDefinition } from '@fortawesome/fontawesome-svg-core'
import { faGauge, faChartBar } from '@fortawesome/pro-regular-svg-icons'

export interface Route {
  location: string
  label: string
  icon: IconDefinition
}

const botzappingRoutes: Route[] = [
  {
    location: '/dashboard',
    label: 'Dashboard',
    icon: faGauge,
  },
  {
    location: '/blocks-report',
    label: 'Detailed Report',
    icon: faChartBar,
  },
]

export default botzappingRoutes
